import { Component, OnInit } from '@angular/core';
import { Cobertura } from '../../modelos/cotizacion.model';

@Component({
  selector: 'cotizacion-detalle',
  templateUrl: './cotizacion-detalle.component.html',
  styleUrls: ['./cotizacion-detalle.component.css']
})

export class CotizacionDetalleComponent implements OnInit {

  public tipo: number;
  public coberturas: Array<Cobertura> = [];
  public asegId: number = 0;
  public coberturaSobre: number = 0;

  constructor() { }

  ngOnInit() {
  }

  formatSA(texto: string) {
    if (isNaN(Number(texto))) {
      return texto;
    } else {
      if (parseInt(texto) > 0) {
        return this.getFormatMoney(Number(texto));
      } else {
        return '0%';
      }

    }
  }

  getFormatMoney(money) {
    if (money == null) {
      return money;
    } else {
      return '$ ' + money.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
    }
  }

  getFormatPorcentaje(money) {
    if (money == null) {
      return money;
    } else {
      return money.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,") + '%';
    }
  }

  formatDED(dato) {
    if (dato == '') {
      return 'N/A';
    } else {
      if (this.asegId === 49 || this.asegId === 22) {
        return dato + ' %';
      } else {
        return this.formatSA(dato);
      }
    }
  }

  validacionDed(texto: String) {
    if (texto && texto == '') {
      return 'N/A';
    } else {
      if (isNaN(Number(texto))) {
        return texto;
      } else {
        return this.getFormatPorcentaje(Number(texto));
      }
    }
  }

  validDmRt(txt: string): boolean {
    if (txt.toLowerCase() == 'danos materiales' || txt.toLowerCase() == 'daños materiales'
      || txt.toLowerCase() == 'robo total' || txt.toLowerCase() == 'daños materiales pérdida parcial') {
      return true;
    }
    return false;
  }

  setTxtDmRt(val: string): string {
    let txt = "";
    try {
      if ((!isNaN(Number(val))) && Number(val) > 0) {
        txt = this.getFormatMoney(Number(val));
      } else {
        switch (Number(this.coberturaSobre)) {
          case 1:
            txt = "VALOR COMERCIAL";
            break;
          case 2:
            txt = "VALOR FACTURA";
            break;
        }
      }
    } catch (e) {
      console.log(e);
    }
    return txt;
  }
}
